import { AlkLogger } from '@alk/core';
import { EBlotterTab } from '../../enums';
import { GridOptions } from '@ag-grid-community/core';
import { IBlotterService } from './blotter.interface';
import { IBlotterUpdate } from '../../interfaces';
import { injectable } from 'inversify';
import { NEVER, Observable } from 'rxjs';

@injectable()
export class BlotterServiceMock implements IBlotterService {
    type: EBlotterTab;
    gridOptions = (): Promise<GridOptions> => Promise.resolve({} as GridOptions);

    ordersObservable = (): Observable<IBlotterUpdate> => NEVER;

    reset() {
        AlkLogger.debug('[BlotterServiceMock#reset]');
    }
}
